import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './tableHeader.css';

const TableHeader = props => {
  const titleStyle = props.intervalTimetable ? { fontSize: '19.5px' } : undefined;
  const header = (
    <div className={styles.inline}>
      <span className={styles.strong}>
        {' '}
        &nbsp;&nbsp;
        {props.subtitleSw}
      </span>
      <span className={styles.strong}>
        &nbsp;&nbsp;
        {props.subtitleEn}
      </span>
    </div>
  );
  return (
    <div className={styles.root}>
      <div
        className={classNames(styles.title, { [styles.compactTitle]: props.useCompactLayout })}
        style={titleStyle}>
        <span className={styles.strong}>{props.title}</span>
        {header}
      </div>
      {props.intervalTimetable || (
        <>
          <div
            className={classNames(styles.subtitle, {
              [styles.compactSubtitle]: props.useCompactLayout,
            })}>
            <div className={styles.strong}>Tunti</div>
            <div>
              <span className={styles.strong}>min</span> / linja Ajat ovat arvioituja
            </div>
          </div>
          <div
            className={classNames(styles.subtitle, {
              [styles.compactSubtitle]: props.useCompactLayout,
            })}>
            <div className={styles.strong}>Timme</div>
            <div>
              <span className={styles.strong}>min</span> / linje Tiderna är beräknade
            </div>
          </div>
          <div
            className={classNames(styles.subtitle, {
              [styles.compactSubtitle]: props.useCompactLayout,
            })}>
            <div className={styles.strong}>Hour</div>
            <div>
              <span className={styles.strong}>min</span> / route The times are estimates
            </div>
          </div>
        </>
      )}
    </div>
  );
};

TableHeader.defaultProps = {
  printingAsA4: false,
  printAsA3: false,
  useCompactLayout: false,
  intervalTimetable: false,
};

TableHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitleSw: PropTypes.string.isRequired,
  subtitleEn: PropTypes.string.isRequired,
  printingAsA4: PropTypes.bool,
  printAsA3: PropTypes.bool,
  useCompactLayout: PropTypes.bool,
  intervalTimetable: PropTypes.bool,
};

export default TableHeader;
